import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { notification } from 'antd';
import useGlobalState from '../../../Template/atoms/variables';
import { useEffect } from 'react';
import { sleep } from '../../../helpers/misc';
import { useMsal } from '@azure/msal-react';
import { useTranslation } from 'react-i18next';
import { getExistingAssetTrees } from '../../helpers/apiCalls';
import useMaintenanceState from '../../atoms/variables';

const PlantsOutlet = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { plantId } = useParams();
  const { instance } = useMsal();
  const [notificationApi, contextHolder] = notification.useNotification();

  const { setPendingApiCalls } = useGlobalState();
  const { setExistingAssetTrees, setChosenPlant } = useMaintenanceState();

  return (
    <>
      {contextHolder}
      <Outlet />
    </>
  );
};

export default PlantsOutlet;
